module.exports = __webpack_public_path__ + "img/icon-01.51bd7a41.svg";